/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/
import {
    INode,
    IvalidationRuleTypes,
    ValidationRule,
} from '@/components/survey/SurveyModel/types/nodeTypes'
import { FieldState } from './types/commonTypes'

const ValidationManager = (function () {
    const defaultForm: FieldState = {
        value: '',
        rules: {},
    }

    const applyCommonValidationsWithValue = (
        node: INode,
        value: any
    ): FieldState => {
        if (node) {
            let rules: ValidationRule = {} // Initialize as an empty object
            node?.validations?.forEach((rule) => {
                const typedRule = rule as IvalidationRuleTypes
                switch (typedRule.type) {
                    case 'required': {
                        rules = {
                            ...rules,
                            required: {
                                message: typedRule.message,
                            },
                        }
                        break
                    }
                    case 'numeric': {
                        rules = {
                            ...rules,
                            numeric: {
                                message: typedRule.message,
                            },
                        }
                        break
                    }
                    case 'format': {
                        rules = {
                            ...rules,
                            format: {
                                message: typedRule.message,
                                regex: /^$|^(\+44\s?\d{4}|\d{5})\s?\d{3}\s?\d{3}$/,
                            },
                        }
                        break
                    }
                    case 'CompareEmpty':
                        {
                            rules = {
                                ...rules,
                                CompareEmpty: {
                                    message: typedRule.message,
                                    field: typedRule.field,
                                    CompareEmpty: () => {
                                        return typedRule.field
                                    },
                                },
                            }
                        }
                        break
                    case 'CompareEmptyList': {
                        rules = {
                            ...rules,
                            CompareEmptyList: {
                                message: typedRule.message,
                                field: typedRule.field,
                                CompareEmptyList: () => {
                                    return typedRule.field
                                },
                            },
                        }
                        break
                    }
                    case 'requiredIf': {
                        rules = {
                            ...rules,
                            requiredIf: {
                                message: typedRule.message,
                                field: typedRule.field,
                                requiredIf: () => {
                                    return { nodeName: node.name, expression: typedRule.expression || "" };
                                }
                            },
                        }
                        break
                    }
                }
            })

            return {
                ...defaultForm,
                value: value ? value : '',
                rules: rules ? rules : {},
            }
        }
        return defaultForm
    }

    return {
        applyCommonValidationsWithValue,
    }
})()

export default ValidationManager
